import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@moe/oss/ui/form";
import { Textarea } from "@moe/oss/ui/textarea";
import { characterConfig } from "@moe/priv/model/character";
import * as Accordion from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import { TokenCounter } from "@web/components/TokenCounter";
import { AlternativeGreetingsField } from "@web/route-services/studio/AlternativeGreetingsField";
import { AnimatePresence, motion } from "motion/react";
import { useFormContext } from "react-hook-form";
import { MessageExamplesField } from "./MessageExamplesField";
import { BaseData } from "./schema";

export function AdvanceFields() {
  const form = useFormContext<BaseData>();

  return (
    <Accordion.Root type="single" collapsible>
      <Accordion.Item value="advanced-fields">
        <Accordion.Header>
          <Accordion.Trigger className="text-tx-tertiary hover:text-tx-primary group flex w-full items-center justify-between py-2 text-left font-semibold transition duration-300 ease-in-out md:text-base">
            Advanced
            <ChevronDownIcon className="group-hover:text-tx-primary h-6 w-6 transition-transform duration-300 ease-in-out group-data-[state=open]:rotate-180" />
          </Accordion.Trigger>
        </Accordion.Header>
        <AnimatePresence initial={false}>
          <Accordion.Content asChild>
            <motion.div
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: "auto" },
                collapsed: { opacity: 0, height: 0 }
              }}
              transition={{
                duration: 0.3,
                ease: [0.04, 0.62, 0.23, 0.98]
              }}
              className="overflow-hidden"
            >
              <div className="space-y-6 pt-4">
                <FormField
                  control={form.control}
                  name="alternativeGreetings"
                  render={({ field }) => (
                    <FormItem>
                      <FormControl>
                        <AlternativeGreetingsField value={field.value} onChange={field.onChange} />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="definitions"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel className="text-tx-secondary flex w-full items-center justify-between">
                        <span className="font-semibold md:text-lg">Lore</span>
                        <TokenCounter content={field.value} />
                      </FormLabel>
                      <FormControl>
                        <Textarea
                          placeholder="Additional character lore, story, background information about the world, scenario, etc... These are non permanent tokens."
                          className="text-base font-medium"
                          {...field}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name="messageExamples"
                  render={({ field }) => (
                    <FormItem>
                      <FormControl>
                        <MessageExamplesField
                          value={field.value}
                          onChange={field.onChange}
                          maxLength={characterConfig.msgExamplesMaxChars}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
            </motion.div>
          </Accordion.Content>
        </AnimatePresence>
      </Accordion.Item>
    </Accordion.Root>
  );
}
